import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timezonedms',
  standalone: true
})

export class TimeZoneDMSDataPipe implements PipeTransform {

  transform(value: string | Date | null, format?: string): string {
    if (!value) return '';

    const userTimezone = moment.tz.guess();
    return moment.utc(value).tz(userTimezone).format(format);
  }
}